/**
 * @generated SignedSource<<0748e278f495a4ae94f48b425046e45b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatabaseActionMenuQuery$variables = Record<PropertyKey, never>;
export type DatabaseActionMenuQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"DatabaseActionMenu_viewer">;
  };
};
export type DatabaseActionMenuQuery = {
  response: DatabaseActionMenuQuery$data;
  variables: DatabaseActionMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DatabaseActionMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatabaseActionMenu_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DatabaseActionMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "App",
                "kind": "LinkedField",
                "name": "apps",
                "plural": true,
                "selections": [
                  (v0/*:: as any*/),
                  (v1/*:: as any*/),
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organizationSlug",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organizations",
                "plural": true,
                "selections": [
                  (v0/*:: as any*/),
                  (v1/*:: as any*/),
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "apps",
                    "plural": true,
                    "selections": [
                      (v0/*:: as any*/),
                      (v1/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4592db388d0016fe53cfc8502de17c41",
    "id": null,
    "metadata": {},
    "name": "DatabaseActionMenuQuery",
    "operationKind": "query",
    "text": "query DatabaseActionMenuQuery {\n  viewer {\n    ...DatabaseActionMenu_viewer\n  }\n}\n\nfragment DatabaseActionMenu_viewer on Viewer {\n  me {\n    id\n    apps {\n      id\n      name\n      slug\n      organizationSlug\n    }\n    organizations {\n      id\n      name\n      slug\n      apps {\n        id\n        name\n        slug\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af0f9fd87ab0b7a8745e924db5ed8a2b";

export default node;
